//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MyInfo from './components/info/myInfo.vue'
import OtherInfo from './components/info/otherInfo.vue'
import PayType from './components/info/payType.vue'

import Basefoot  from './components/Basefoot'
import InstructionProtocol from "@/components/instructionProtocol/index.vue";
import { store } from '@/observable/store'
import { InsurStore,InsurMutations } from './store'
import { insurance } from '@/model/api/detailService'
import { CacheModule,setSessionParme ,deepClone} from '@/utils/commonUtils'


import {infoMyFrom, infoOtherFrom,tabList,tabTypeList} from './components/from/config'
import Txrweb from '@/utils/mixin/mixinTxrweb'
import clearKeepAlive from '@/utils/mixin/mixinCache'
import InsuranceReview from '@/utils/mixin/InsuranceReview'
import { Parameter } from '@/utils/orderParme'
import NewProtocol from '@/components/newProtocol/index.vue'

    export default {
        name:'insuranceInfo',
        mixins:[clearKeepAlive,Txrweb,InsuranceReview],
        data() {
            return {
                // key: value
                MyFrom:[],
                OtherFrom:[],
                tabList:[],
                tabTypeList:[],
                load:false,
                protocolInfo:{}
            }
        },
        components: {
            MyInfo,
            OtherInfo,
            PayType,
            Basefoot,
            InstructionProtocol,
            NewProtocol
        },
        created () {
          this.MyFrom = deepClone(infoMyFrom);
          this.tabList = tabList;
          this.tabTypeList = tabTypeList;
          if(!Object.keys(this.insurance).length){
            this.getInfo()
          }else{
            this.load = true

          }

        },
        beforeRouteLeave(to, form, next) {
          CacheModule.sessionStorageRemove('cook_last_info');
          next()
        },
        computed: {
          modify(){
            return this.$route.query.modify
          },
          templateFlag(){
            return this.$route.query.templateFlag
          },
          insurance(){
            return InsurStore.insurance
          },
        },
        mounted () {
          this.infoTX()
          this.STATISTICS_CONFIG.insur_insurinfoinput_page();
        },
        methods: {
            // 点击确认
            btnClick() {
              // check 方法校验规则并返回规则通过的值， 不通过返回false
              const applicant = this.$refs.MyFrom.check(); //投保人信息 
              if(applicant){
                  const insure = this.$refs.OtherFrom.check() //被保人信息 
                  if(insure){
                    this.$refs.instructionProtocol.checkSelectFlag().then((bol)=>{
                      if(bol){
                        this.creat(applicant,insure)
                      }else{
                        this.protocolInfo={
                          productName:"齐牙保PLUS(互联网)",   //齐牙保保险方案写死
                          buyerName:applicant.name,
                          insuredName:insure.name || applicant.name
                        }
                        this.$refs.newProtocol.modeShow=true
                      }
                    }).catch(err=>{
                      console.log(err)
                    })
                  }
              }
            },
            // 获取保险信息
            getInfo(){
                let plan = `${this.templateFlag}?modify=${this.modify}`
                insurance(plan).then(data=>{
                    InsurMutations.insurance(data);
                    this.load = true
                })
       
            },
            tabHandler(index){ //被保人切换 获取ifrom列表
              index == 0 ? this.OtherFrom = [] : this.OtherFrom = deepClone(infoOtherFrom);
            },
            custUrlClick(){
              this.STATISTICS_CONFIG.insur_insurinfoinput_contactonline_click();
              // 点击客服 获取当前页面信息 并存储在浏览器中 
              const applicant = this.$refs.MyFrom.info(); //投保人信息 
              const insure = this.$refs.OtherFrom.info() //被保人信息 
              const cook_last_info = {
                "applicant":applicant,
                "insure":insure,
                "relation":InsurStore.relation
              }
              CacheModule.setSessionStorage("cook_last_info",cook_last_info)
              
            },
            creat(applicant,insure){
              console.log('benren',applicant);
              console.log('taren',insure);
              // return false
               let parmer = {
                  modify: this.modify,
                  pay_period: InsurStore.pay_period, // 年缴,
                  source: 1, //来源id
                  applicant: applicant,
                  insure: [
                    {
                      //被保人对象
                      ...insure,
                      coverage: 600000000, //保额
                      relation: InsurStore.relation, //被保人 
                      social_security: InsurStore.social_security, //0-无社保, 1-有社保 
                      amount: InsurStore.amount, //实付金额
                      payable_amount: this.insurance.payable_amount, //应付金额
                      extra_enums: 0, //0-无操作, 1-智齿拔除意外 
                    },
                  ],
                  template: this.templateFlag, // 接口名
                  pay_action: InsurStore.pay_action, //支付方式(paid-支付, entrust-签约代扣)
                  amount: InsurStore.amount, //实付金额 
                  payable_amount: this.insurance.payable_amount, //应付金额
                  from_salesman: this.$route.query.from_salesman || "",
                  traceback: store.TXoption.bizKey,
                  stage_active:this.insurance.stage_info.stage_active, //是否签约 用于在核保页判断是否签约
                  last_policy_id:this.insurance.last_identity_info.policy_id || 0
                  
                };
                console.log(parmer)

                const parameter = Parameter(parmer);
                // console.log(parameter)
                // 核保
                this.insuranceToReview(parameter,'creatOrder')

            },
            // 授权弹窗
            submitClick(){
              this.$refs.instructionProtocol.selectFlag=true
              this.btnClick()
            }
        },
    }
